



















import PageLayout from '@/components/page/PageLayout.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import { add, bignumber, subtract } from 'mathjs'
import addPlan from './addPlan.vue'
import addTask from './addTask.vue'
import LawsuitApi from '@/api/lawsuit'

@Component({
	name: 'addLawsuitTask',
	components: {
		PageLayout,
		addPlan,
		addTask,
	},
})
export default class addTaskPage extends Vue {
	private showPlan = false
	private data: any = {}

	private get feeList() {
		let res: any = ['otherFee']
		if (
			!this.data.includeFormType ||
			['01', '03'].includes(this.data.includeFormType)
		) {
			res.push(
				'currentMedicalFee',
				'furtherMedicalFee',
				'nutritionFee',
				'plasticFee',
				'mealFee',
				'fareFee',
				'liveFee',
				'absentFee',
				'recoveryFee',
				'careFee',
				'deviceFee',
				'metalFee',
				'injuredFee',
				'dependentFee'
			)
		}
		if (
			!this.data.includeFormType ||
			['02', '03'].includes(this.data.includeFormType)
		) {
			res.push('carstuffFee', 'suspensionFee')
		}
		if (!this.data.death || this.data.death === '1') {
			res.push('funeralFee', 'deadFee')
		}
		return res
	}

	private setPlan() {
		this.showPlan = true
		window.scrollTo(0, 0)
	}

	private getFilterScheme() {
		let schemeList = []
		let originScheme = cloneDeep(this.data.submitScheme)
		let compulsorySum: any = bignumber(originScheme.compulsorySum)
		let commercialSum: any = bignumber(originScheme.commercialSum)
		// 切换选项后过滤已不存在的费用项，并在总额中减去
		schemeList = originScheme.schemeList.filter((item: any) => {
			if (!this.feeList.includes(item.itemType)) {
				compulsorySum = subtract(compulsorySum, bignumber(item.compulsory))
				commercialSum = subtract(commercialSum, bignumber(item.commercial))
			}
			return this.feeList.includes(item.itemType)
		})
		return {
			schemeList,
			compensationSum: add(compulsorySum, commercialSum).valueOf(),
			compulsorySum: compulsorySum.valueOf(),
			commercialSum: commercialSum.valueOf(),
		}
	}

	private setData(key: string, value: any) {
		this.$set(this.data, key, value)
		// 设置应诉方案后切换选项
		if (this.data.submitScheme) {
			this.$set(this.data, 'scheme', this.getFilterScheme())
		}
	}

	private submitPlan(scheme: any) {
		// data.submitScheme用于保存应诉方案提交的scheme
		this.$set(this.data, 'submitScheme', scheme)
		// data.scheme用于保存includeFormType,death改变后的scheme，也是最终提交的scheme
		this.$set(this.data, 'scheme', scheme)
	}

	private hidePlan() {
		this.showPlan = false
	}
}
